__turbopack_context__.v({
  "accordion": "StaticPage-module__7yRX_a__accordion",
  "accordionAnswer": "StaticPage-module__7yRX_a__accordionAnswer",
  "accordionDetails": "StaticPage-module__7yRX_a__accordionDetails",
  "accordionExpandIcon": "StaticPage-module__7yRX_a__accordionExpandIcon",
  "accordionSummary": "StaticPage-module__7yRX_a__accordionSummary",
  "active": "StaticPage-module__7yRX_a__active",
  "bodyText": "StaticPage-module__7yRX_a__bodyText",
  "bodyTextSm": "StaticPage-module__7yRX_a__bodyTextSm",
  "breadcrumbBar": "StaticPage-module__7yRX_a__breadcrumbBar",
  "bulletList": "StaticPage-module__7yRX_a__bulletList",
  "categoryHeader": "StaticPage-module__7yRX_a__categoryHeader",
  "categoryIconBox": "StaticPage-module__7yRX_a__categoryIconBox",
  "categoryTitle": "StaticPage-module__7yRX_a__categoryTitle",
  "checkItem": "StaticPage-module__7yRX_a__checkItem",
  "checkList": "StaticPage-module__7yRX_a__checkList",
  "chip": "StaticPage-module__7yRX_a__chip",
  "chipRow": "StaticPage-module__7yRX_a__chipRow",
  "container": "StaticPage-module__7yRX_a__container",
  "contentColumn": "StaticPage-module__7yRX_a__contentColumn",
  "contentSection": "StaticPage-module__7yRX_a__contentSection",
  "contentText": "StaticPage-module__7yRX_a__contentText",
  "ctaButton": "StaticPage-module__7yRX_a__ctaButton",
  "ctaButtonOutline": "StaticPage-module__7yRX_a__ctaButtonOutline",
  "ctaButtons": "StaticPage-module__7yRX_a__ctaButtons",
  "ctaSection": "StaticPage-module__7yRX_a__ctaSection",
  "ctaText": "StaticPage-module__7yRX_a__ctaText",
  "ctaTitle": "StaticPage-module__7yRX_a__ctaTitle",
  "dataTable": "StaticPage-module__7yRX_a__dataTable",
  "divider": "StaticPage-module__7yRX_a__divider",
  "expanded": "StaticPage-module__7yRX_a__expanded",
  "featureCard": "StaticPage-module__7yRX_a__featureCard",
  "featureCheckItem": "StaticPage-module__7yRX_a__featureCheckItem",
  "featureDescription": "StaticPage-module__7yRX_a__featureDescription",
  "featureGrid": "StaticPage-module__7yRX_a__featureGrid",
  "featureIconBox": "StaticPage-module__7yRX_a__featureIconBox",
  "featureTitle": "StaticPage-module__7yRX_a__featureTitle",
  "heroDate": "StaticPage-module__7yRX_a__heroDate",
  "heroInner": "StaticPage-module__7yRX_a__heroInner",
  "heroSection": "StaticPage-module__7yRX_a__heroSection",
  "heroSubtitle": "StaticPage-module__7yRX_a__heroSubtitle",
  "heroTitle": "StaticPage-module__7yRX_a__heroTitle",
  "infoBox": "StaticPage-module__7yRX_a__infoBox",
  "lastUpdated": "StaticPage-module__7yRX_a__lastUpdated",
  "legalLayout": "StaticPage-module__7yRX_a__legalLayout",
  "letterList": "StaticPage-module__7yRX_a__letterList",
  "mainGrid": "StaticPage-module__7yRX_a__mainGrid",
  "mvvCard": "StaticPage-module__7yRX_a__mvvCard",
  "mvvCardMission": "StaticPage-module__7yRX_a__mvvCardMission",
  "mvvCardValues": "StaticPage-module__7yRX_a__mvvCardValues",
  "mvvCardVision": "StaticPage-module__7yRX_a__mvvCardVision",
  "mvvDesc": "StaticPage-module__7yRX_a__mvvDesc",
  "mvvGrid": "StaticPage-module__7yRX_a__mvvGrid",
  "mvvHeader": "StaticPage-module__7yRX_a__mvvHeader",
  "mvvTitle": "StaticPage-module__7yRX_a__mvvTitle",
  "numberedList": "StaticPage-module__7yRX_a__numberedList",
  "offerCard": "StaticPage-module__7yRX_a__offerCard",
  "offerCardDesc": "StaticPage-module__7yRX_a__offerCardDesc",
  "offerCardIcon": "StaticPage-module__7yRX_a__offerCardIcon",
  "offerCardTitle": "StaticPage-module__7yRX_a__offerCardTitle",
  "offerGrid": "StaticPage-module__7yRX_a__offerGrid",
  "open": "StaticPage-module__7yRX_a__open",
  "pageWrapper": "StaticPage-module__7yRX_a__pageWrapper",
  "questionText": "StaticPage-module__7yRX_a__questionText",
  "section": "StaticPage-module__7yRX_a__section",
  "sectionTitle": "StaticPage-module__7yRX_a__sectionTitle",
  "sectionTitleCentered": "StaticPage-module__7yRX_a__sectionTitleCentered",
  "sectionTitlePlain": "StaticPage-module__7yRX_a__sectionTitlePlain",
  "sidebarCard": "StaticPage-module__7yRX_a__sidebarCard",
  "sidebarCardText": "StaticPage-module__7yRX_a__sidebarCardText",
  "sidebarCardTitle": "StaticPage-module__7yRX_a__sidebarCardTitle",
  "sidebarColumn": "StaticPage-module__7yRX_a__sidebarColumn",
  "sidebarContactInfo": "StaticPage-module__7yRX_a__sidebarContactInfo",
  "sidebarContactRow": "StaticPage-module__7yRX_a__sidebarContactRow",
  "sidebarHelpBox": "StaticPage-module__7yRX_a__sidebarHelpBox",
  "sidebarHelpBox2": "StaticPage-module__7yRX_a__sidebarHelpBox2",
  "sidebarNeedHelp": "StaticPage-module__7yRX_a__sidebarNeedHelp",
  "stepCard": "StaticPage-module__7yRX_a__stepCard",
  "stepDesc": "StaticPage-module__7yRX_a__stepDesc",
  "stepIconCircle": "StaticPage-module__7yRX_a__stepIconCircle",
  "stepNumber": "StaticPage-module__7yRX_a__stepNumber",
  "stepTitle": "StaticPage-module__7yRX_a__stepTitle",
  "stepsGrid": "StaticPage-module__7yRX_a__stepsGrid",
  "subSectionTitle": "StaticPage-module__7yRX_a__subSectionTitle",
  "subSectionTitleAbout": "StaticPage-module__7yRX_a__subSectionTitleAbout",
  "toc": "StaticPage-module__7yRX_a__toc",
  "tocDivider": "StaticPage-module__7yRX_a__tocDivider",
  "tocItem": "StaticPage-module__7yRX_a__tocItem",
  "tocItemActive": "StaticPage-module__7yRX_a__tocItemActive",
  "tocList": "StaticPage-module__7yRX_a__tocList",
  "tocSidebar": "StaticPage-module__7yRX_a__tocSidebar",
  "tocTitle": "StaticPage-module__7yRX_a__tocTitle",
  "valueCard": "StaticPage-module__7yRX_a__valueCard",
  "valueDescription": "StaticPage-module__7yRX_a__valueDescription",
  "valueIconBox": "StaticPage-module__7yRX_a__valueIconBox",
  "valueItemDesc": "StaticPage-module__7yRX_a__valueItemDesc",
  "valueItemIcon": "StaticPage-module__7yRX_a__valueItemIcon",
  "valueItemRow": "StaticPage-module__7yRX_a__valueItemRow",
  "valueItemTitle": "StaticPage-module__7yRX_a__valueItemTitle",
  "valueTitle": "StaticPage-module__7yRX_a__valueTitle",
  "valuesGrid": "StaticPage-module__7yRX_a__valuesGrid",
  "whyCard": "StaticPage-module__7yRX_a__whyCard",
  "whyCardIcon": "StaticPage-module__7yRX_a__whyCardIcon",
  "whyCardText": "StaticPage-module__7yRX_a__whyCardText",
  "whyCardTextItalic": "StaticPage-module__7yRX_a__whyCardTextItalic",
  "whyCardTitle": "StaticPage-module__7yRX_a__whyCardTitle",
  "whyGrid": "StaticPage-module__7yRX_a__whyGrid",
});
